import React, { Component } from "react";
import {Card,Form, Table, Spin, DatePicker, Row, Col, Button} from "antd";
import getDate from 'util/ConfigDates'
import Details from './Details';
import DateHour from './DateHour';
import ModalDelete from './ModalDelete';
import Moment from 'moment';
import { connect } from "react-redux";
import SelectUpdateStatus from './SelectUpdateStatus';
import {
  fetchOrders,
} from "appRedux/actions/Orders";

function confirm(e) {
}

function cancel(e) {
}

function status(status){
  if(status==0){
    return "Pendiente"
  }else if(status==1){
    return "En curso"
  }else if(status==2){
    return "Completado"
  }else{
    return "Cancelado"
  }
}

const FormItem = Form.Item

class Simple extends Component {

  constructor(props) {
    super(props)
    this.state = {
      dateFrom:getDate('dateFrom'),
      dateTo:getDate('dateTo') //getDate('dateTo'),
    }
  }
  
  state = {
    dateFrom: getDate('dateFrom'),
    dateTo: getDate('dateTo'),
  }
  
  componentDidMount () {
    this.props.fetchOrders(this.state)
  }
  
  onClickDateFrom = (date, dateString) => {
    console.log(dateString);
    this.setState({dateFrom: dateString})
  }

  onClickDateTo = (date, dateString) => {
    console.log(dateString);
    this.setState({dateTo: dateString})
  }

  onHandleClick = event => {
    event.preventDefault()
    if (this.state.dateFrom !== '' && this.state.dateTo !== '') {
      
      console.log(this.state);
      this.props.fetchOrders(this.state)
    }
  }

  render () {
    const {dateFrom, dateTo} = this.state
    const columns = [
      
      {
        title: 'Nombre ',
        dataIndex: 'name',
        key: 'name',
        }, {
        title: 'Fecha del pedido',
        dataIndex: 'date',
        key: 'date'
      },

      {
        title: 'Estado',
        key: 'action',
      
        render: (text, record) => (
       
          <span>
            <SelectUpdateStatus dataState={this.state} recording = {record} />
          </span>
        ),
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
      },

      {
        title: 'Eliminar',
        key: 'action',
      
        render: (text, record) => (
          <span>
            <ModalDelete dataState={this.state} recording = {record} />
          </span>
        ),
      },
      {
        key: 'edit',
        render: (text, record) => (
          <span>
            <Details dataState={this.state} recording = {record} />
          </span>
        ),
      },
      {
        key: 'details',
        render: (text, record) => (
          <span>
            <DateHour dataState={this.state} recording = {record} />
          </span>
        ),
      }
    ];
    
    const { orders } = this.props;
    //console.log(orders);

    let orderDecode = [];
    orderDecode = orders.map( (orders)=> {
      return ({
        key:orders.idorder,
        id: orders.idorder,
        name: orders.full_name,
        email: orders.email,
        phone: orders.phone,
        total: orders.total,
        status: status(orders.delivery_status),
        date: orders.order_date,
        location: orders.address_signs,
        longitude: orders.longitude,
        latitude:orders.latitude,
        delivery_status: orders.delivery_status,
        days_of_collection:orders.days_of_collection,
        address_description:orders.address_description

      })
    });



    return (
      <Card title="Pedidos">
        <br/>
          <Card>
          <Row className="padding-modal">      
          <Col lg={10} md={10} sm={10} xs={10}>
          <FormItem
            label="Desde :"
          >
          <DatePicker renderExtraFooter={() => 'extra footer'} defaultValue={Moment(dateFrom)} onChange={this.onClickDateFrom} placeholder="Desde:"/>
          </FormItem>
          </Col>
          <Col lg={10} md={10} sm={10} xs={10}>
          <FormItem
            label="Hasta :"
          >
          <DatePicker renderExtraFooter={() => 'extra footer'} defaultValue={Moment(dateTo).add('days',7)} onChange={this.onClickDateTo} placeholder="Hasta:"/>
          </FormItem>
          </Col>
          <Col lg={4} md={4} sm={4} xs={4}>
              <Button type="primary" onClick={this.onHandleClick}>
                <i className="icon icon-search" />
              </Button>
            </Col>
          </Row>
          </Card>
        <br/>
        <Table className="gx-table-responsive" columns={columns} pagination={true}  dataSource={orderDecode}/>
      </Card>
    );
  }
};

function mapStateToProps({orders}) {
  return {
    orders
  }
}

export default connect (mapStateToProps, { fetchOrders })(Simple);


// WEBPACK FOOTER //
// ./src/routes/main/Orders/Table.js